<template>
	<div class="explanation-modal">
		<h3 class="heading">{{ heading }}</h3>
		<div class="wysiwyg-content" v-html="content" />
		<a class="close-btn" @click="deactivateModal">
			<svg viewBox="0 0 18.85 18.85" xmlns="http://www.w3.org/2000/svg" v-bind:class="'close-x'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.003 1.529L1.531 0l17.324 17.324-1.528 1.528z" fill="#8eceff"/><path d="M.003 17.311L17.327-.013l1.528 1.528L1.53 18.839z" fill="#8eceff"/></svg>
		</a>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: 'ExplanationModal',
	props: {
		heading: {
			type: String,
			required: true,
		},
		content: {
			type: String,
			required: true,
		},
	},
	methods: {
		...mapActions({
			deactivateModal: "global/modal/deactivate",
		}),
	},
};
</script>

<style lang="scss" scoped>
	.explanation-modal {
		max-width: 800px;
		background: $primary-color-extra-light;
		color: $alt-color-dark;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		border-radius: 20px;
		padding: 5em;

		@include tablet {
			// height: 700px;
			// width: 550px;
		}

		@include desktop {
			// height: 600px;
			// width: 750px;
		}

		@include desktop-sm {
			// height: 500px;
			// width: 675px;
		}
	}

	.heading {
		font-size: $font-size-xxl;
		text-transform: uppercase;
		font-family: $heading-font;
		margin-bottom: .5em;
	}

	.wysiwyg-content {
		margin-bottom: 1.5em;
		text-align: center;
	}

	.close-btn {
		width: 2em;
		display: inline-block;
		padding: .5em;
		border: 1px solid $alt-color-dark;;
		border-radius: 50%;

		path {
			fill: $alt-color-dark;;
		}
	}

</style>
